import { Component, OnInit } from '@angular/core';
import { ChartWidgetContainerService } from './chart-widget-container.service';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { NotificationHandlerService } from '../notifications/notification-handler.service';

@Component({
    selector: 'chart-widget-container',
    templateUrl: 'chart-widget-container.component.html'
})

export class ChartWidgetContainerComponent implements OnInit {

    public allWidgets: string[];

    constructor(private _widgetService: ChartWidgetContainerService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {

    }

    ngOnInit(): void {
        this.getData();
    }

    public getData() {
        this._widgetService
            .GetAll()
            .subscribe(data => {
                this.allWidgets = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                    this._notificationService.handleError(error)
            },
            () => {});
    }

}



// WEBPACK FOOTER //
// ./angularApp/app/shared/chart-widget-container/chart-widget-container.component.ts